var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusSolid = function SvgPlusSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.143 1.143a1.142 1.142 0 1 0-2.286 0v5.714H1.143a1.142 1.142 0 1 0 0 2.286h5.714v5.714a1.142 1.142 0 1 0 2.286 0V9.143h5.714a1.142 1.142 0 1 0 0-2.286H9.143z"
  })));
};
export default SvgPlusSolid;